<script setup>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
</script>

<template>
    <main class="min-h-screen bg-gradient-to-br from-zinc-100 via-zinc-200 to-zinc-100">
        <Navbar />
        <slot />
        <Footer />
    </main>
</template>
